import { render } from "./whiteStatistics.vue?vue&type=template&id=6469580c&scoped=true"
import script from "./whiteStatistics.vue?vue&type=script&lang=js"
export * from "./whiteStatistics.vue?vue&type=script&lang=js"

import "./whiteStatistics.vue?vue&type=style&index=0&id=6469580c&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6469580c"]])

export default __exports__